// This component is for temporary solution of HIX-195133
// It will be refactored later on

import React from 'react';
import styled from 'styled-components';
import { GIButton } from 'app-components';
import { GIButtonProps } from 'app-components/dist/typings/molecules/GIButton';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

interface CapitalizedButtonProps extends GIButtonProps {
    leftMargin?: boolean;
    rightMargin?: boolean;
}

const CapitalizedButton: React.FC<CapitalizedButtonProps> = props => {
    const { leftMargin = false, rightMargin = false, ...rest } = props;
    const  { isState }  = useAppSelector(environmentSelector);

    const isUpperCase = isState.ID;

    const StyledButtonWrapper = styled.section`
        display: inline;
        margin-left: ${leftMargin ? '.5rem' : '0'};
        margin-right: ${rightMargin ? '.5rem' : '0'};

        .gi-button {
            text-transform: ${isUpperCase ? 'uppercase' : 'none'} !important;
        }
    `;

    return (
        <>
            <StyledButtonWrapper>
                <GIButton {...rest} />
            </StyledButtonWrapper>
        </>
    );
};

export default CapitalizedButton;